<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h5 class="mb-3">Event Info</h5>
                <basic-table :fields="tableFields1" name="eventInfo1" :list="[eventInfo]" class="tb-thead-bg"/>
                <basic-table :fields="tableFields2" name="eventInfo2" :list="[eventInfo]" class="mt-3 basic-table-border tb-thead-bg">
                    <template v-slot:clientCd="slotData">
                            {{slotData.data.clientCd | changeOptionsValueToText(clientCdOptions)}}
                    </template>
                    <template v-slot:notiCateCd="slotData">
                        <template v-for="(item,index) in notiCateCdOptions">
                            <span v-if="item.value === slotData.data.notiCateCd" :key="'noticateCd'+index">{{item.text}}</span>
                        </template>
                    </template>
                    <template v-slot:notiTypeCd="slotData">
                        <template v-for="(item,index) in notiTypeCdOptions">
                            <span v-if="item.value === slotData.data.notiTypeCd" :key="'notiTypeCd'+index">{{item.text}}</span>
                        </template>
                    </template>
                </basic-table>
                <basic-table :fields="tableFields3" name="eventInfo3" :list="[eventInfo]" class="mt-3 basic-table-border tb-thead-bg"/>
            </div>
        </div>
        <message-comp :queue-type="eventInfo.queueType" :info="eventInfo" :modify="false" v-if="hasRole($const.ROLES.TEMPLATE_SAVE)"/>
        <template v-for="(item,index) in eventInfo.messages">
            <message-comp :queue-type="eventInfo.queueType" :info="item" :key="eventId + index"/>
        </template>
    </div>
</template>

<script>
    import BasicTable from "@/components/form/table/BasicTable";
    import MessageComp from "@/page/template/event/MessageComp";
    export default {
        name: "TemplateMngInEventType",
        components:{
            MessageComp,
            BasicTable
        },
        data() {
            return {
                tableFields1: [
                    {key:'eventId',label:'Event Id',width:'33.3%'},
                    {key:'eventNm',label:'Name',width:'33.3%'},
                    {key:'paramCnt',label:'Parameter Count',width:'33.3%'},

                ],
                tableFields2: [
                    {key:'clientCd',label:'Client Code',width:'33.3%',slot:'clientCd'},
                    {key:'notiTypeCd',label:'Notification Type Code',width:'33.3%',slot:'notiTypeCd'},
                    {key:'notiCateCd',label:'Notification Category Code',width:'33.3%',slot:'notiCateCd'},
                ],
                tableFields3: [
                    {key:'usrYn',label:'User No. required',width:'33.3%'},
                    {key:'custYn',label:'Customer No. required',width:'33.3%'},
                    {key:'notiCenterYn',label:'Show Notification Center',width:'33.3%'},
                ],
                // eventInfo: {}
            }
        },
        computed: {
            eventId: function () {
                return this.$route.query.eventId
            },
            notiTypeCdOptions: function () {
                return this.$store.getters[this.$const.GETTERS.NOTI_TYPE_CD_OPTIONS]()
            },
            notiCateCdOptions: function() {
                return this.$store.getters[this.$const.GETTERS.NOTI_CATE_CD_OPTIONS]()
            },
            clientCdOptions: function() {
                return this.$store.getters[this.$const.GETTERS.CLIENT_CD_OPTIONS]()
            },
            eventInfo: function () {
                return this.$store.getters[this.$const.GETTERS.STORED_EVENT_INFO]()
            }
        },
        mounted() {
            if(!this.eventId) this.$router.go(-1)

            this.$store.dispatch(this.$const.ACTIONS.SET_LAYOUTS,{size:10000})
            this.$store.dispatch(this.$const.ACTIONS.CALL_EVENT_INFO,{eventId: this.eventId})
        },
        methods: {
        },
    }
</script>

<style scoped>

</style>
